import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import type { Theme } from '@mui/material/styles';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import classNames from 'classnames';

interface ProgressStepsProps {
  numberOfSteps: number;
  currentStep: number;
}

const useStyles = makeStyles()((theme: Theme) => ({
  stepIcon: {
    color: theme.palette.grey[500],
    fontSize: 28,
  },
  stepIconDone: {
    color: theme.palette.primary.main,
  },
  stepIconCurrent: {
    color: theme.palette.common.white,
  },
  arrowIcon: {
    color: theme.palette.grey[500],
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
    },
  },
  container: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const StepIcon: React.FC<{ isDoneStep: boolean; isCurrentStep: boolean }> = ({
  isDoneStep,
  isCurrentStep,
}) => {
  const { classes } = useStyles();
  const stepIconClass = classNames(classes.stepIcon, {
    [classes.stepIconDone]: isDoneStep,
    [classes.stepIconCurrent]: isCurrentStep,
  });

  return <CheckCircleOutlineIcon className={stepIconClass} />;
};

const ProgressSteps: React.FC<ProgressStepsProps> = ({ numberOfSteps, currentStep }) => {
  const { classes } = useStyles();
  const steps = Array.from({ length: numberOfSteps }, (_, index) => index);

  return (
    <div className={classes.container}>
      {steps.map((step) => (
        <React.Fragment key={step}>
          <StepIcon isDoneStep={step < currentStep} isCurrentStep={step === currentStep} />
          {step < numberOfSteps - 1 && <ArrowRightAltIcon className={classes.arrowIcon} />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ProgressSteps;
